import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer } from 'react-router-redux';
import globalReducer from './reducer/globalReducer';
import usersReducer from './reducer/userReducer';
import chatReducer from './reducer/chatReducer';
import authReducer from './reducer/authReducer';

export default function configureStore(initialState) {
    const reducers = {
        global: globalReducer,
        user: usersReducer,
        chat: chatReducer,
        auth: authReducer
    };

    const middleware = [
        thunk,
    ];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

    const rootReducer = combineReducers({
        ...reducers,
        routing: routerReducer
    });

    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
}
